module.exports = __webpack_public_path__ + "img/sharing.a305e7a9.webp";